import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
import { EmployeeSalary } from '../../personnel-setup/hr-employee-extracted-salary/hr-employee-extracted-salary.service';

let BankTransformerUrl = CONFIG.baseUrls.BankTransformer;
@Injectable()
export class BankTransformerDiscountService {
    constructor(private httpGeneralService: HttpGeneralService) { }

     getBankTransformerDiscount(benfType: number,type :number,benfCode:number,currencyCode:number=0) {
        return this.httpGeneralService.getWith(`${BankTransformerUrl}/Discount/${benfType}/${type}/${benfCode}/${currencyCode}`);
    }
}
